import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card } from 'react-bootstrap';
import useFormGenerator from '../common/FormUtils';
import useButtonsGenerator from '../common/functions/useButtonsGenerator';
import CandidateService from './CandidateService';
import candidateJsonSchema from './candidateJsonSchema';

const CandidateFormModal = ({ show, onHide, candidateId, onCandidateSaved }) => {
  const [data, setData] = useState(null);
  const [validated, setValidated] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show && candidateId) {
      // Load existing candidate if editing
      CandidateService.retrieveCandidate(candidateId)
        .then(candidateData => {
          setData(candidateData);
        })
        .catch(error => console.error('Error loading candidate:', error));
    } else if (show && !candidateId) {
      // Reset for new candidate
      setData({});
    }
  }, [show, candidateId]);

  const handleCandidateFormSubmit = async (formData) => {
    try {
      setSaving(true);
      const savedCandidate = await CandidateService.saveCandidate(formData);
      console.log('Candidate saved:', savedCandidate);
      
      // Call the callback if provided
      if (onCandidateSaved) {
        onCandidateSaved(savedCandidate);
      }
      
      // Close modal
      handleClose();
    } catch (error) {
      console.error('Error saving candidate:', error);
      alert('Error saving candidate. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    setData(null);
    setValidated(false);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {candidateId ? 'Edit Candidate' : 'New Candidate'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {(data !== null || !candidateId) ? (
          <FormGeneratorWithData
            data={data || {}}
            onSubmit={handleCandidateFormSubmit}
            validated={validated}
            setValidated={setValidated}
            saving={saving}
            onCancel={handleClose}
          />
        ) : (
          <p>Loading...</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

const FormGeneratorWithData = ({ 
  data, 
  onSubmit, 
  validated, 
  setValidated, 
  saving,
  onCancel 
}) => {
  const buttonsConf = [
    {
      name: saving ? 'Saving...' : 'Save Candidate',
      type: 'submit',
      variant: 'primary',
      disabled: saving
    },
    {
      name: 'Cancel',
      type: 'button',
      variant: 'secondary',
      onClick: onCancel,
      disabled: saving
    }
  ];

  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  const { formFields, handleSubmit } = useFormGenerator(
    candidateJsonSchema,
    onSubmit,
    data,
    setValidated
  );

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      {formFields}
      <div className="d-flex justify-content-end gap-2 mt-3">
        {buttonsGenerated}
      </div>
    </Form>
  );
};

export default CandidateFormModal;
